import { useSnackbar } from '@hue/design-system';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { getApiError, rootApi } from '../lib/api.js';
import { refreshSession } from '../lib/session.js';

/// Sair da empresa e voltar ao console. Quem faz isso é sempre o root, e a falha precisa ser dita:
/// o botão fica no cabeçalho e o erro aparecia no alto do conteúdo, então quem tinha rolado a
/// página continuava dentro da empresa sem nunca ver o motivo.
///
/// Mora fora da casca porque o mesmo botão existe duas vezes — na faixa de acesso root e no fim da
/// visão geral, para quem está no celular — e a regra é uma só.
export function useLeaveCompany(): { leaving: boolean; leave: () => Promise<void> } {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const [leaving, setLeaving] = useState(false);

  return {
    leaving,
    leave: async () => {
      setLeaving(true);
      try {
        await rootApi.leaveTenant();
        await refreshSession(queryClient);
        await navigate({ to: '/companies' });
      } catch (error) {
        snackbar.failure(getApiError(error));
      } finally {
        setLeaving(false);
      }
    },
  };
}
